import { Injectable } from '@angular/core';
import { Observable } from '@app/shared/rx/rx-wrapper';
import { IApiListResponse } from '@app/shared/types/common/epics.type';
import { IFilterQuery } from '@app/shared/types/common/filter-query.type';
import {
  IBaseEntityType,
  IDocumentOperationOptions,
} from '@app/shared/types/entities/base.type';
import { ENTITY_TYPES } from '@app/shared/types/enums/entityTypes.enum';
import { BaseService } from '../base/base.service';
import { IServiceConfig } from '../base/service-config.type';

@Injectable()
export class EmployeeDataService extends BaseService {
  public static config: IServiceConfig = {
    ENTITY_TYPE: ENTITY_TYPES.EMPLOYEE,
    apiEndpoint: 'boh/employee/get-by-ids',
    customEntityRoute: {
      list: null,
    },
  };

  public fetchList<T = IBaseEntityType>(
    userQuery?: IFilterQuery,
    options: IDocumentOperationOptions = {},
  ): Observable<IApiListResponse<T>> {
    return super.fetchList(userQuery, { ...options, withoutTop: true });
  }
}
